import { render, staticRenderFns } from "./supplierList.vue?vue&type=template&id=64641682&scoped=true&"
import script from "./supplierList.vue?vue&type=script&lang=js&"
export * from "./supplierList.vue?vue&type=script&lang=js&"
import style0 from "./supplierList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./supplierList.vue?vue&type=style&index=1&id=64641682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64641682",
  null
  
)

export default component.exports